export default __webpack_public_path__ + "static/media/canon.2971ac12.svg";